import moment from 'moment';
import 'moment/locale/fr-ca.js';
import { enUS } from 'date-fns/locale/en-US';
import { frCA } from 'date-fns/locale/fr-CA';

// Registering fr-ca becomes moment's global default; keep English until setLocale runs.
moment.locale('en');

export const DEFAULT_LOCALE = 'en';
export const SUPPORTED_LOCALES = ['en', 'fr'];
export const LOCALE_CACHE_KEY = 'ipac.locale';

export const MOMENT_LOCALES = {
    en: 'en',
    fr: 'fr-ca',
};

export const isSupportedLocale = (locale) => {
    return SUPPORTED_LOCALES.includes(locale);
};

export const normalizeLocale = (locale) => {
    return isSupportedLocale(locale) ? locale : DEFAULT_LOCALE;
};

// Moment uses regional locale identifiers while the app stores scalar locales.
export const getMomentLocale = (locale) => {
    return MOMENT_LOCALES[normalizeLocale(locale)];
};

// @vuepic/vue-datepicker uses date-fns for calendar day/month abbreviations.
export const DATE_PICKER_LOCALES = {
    en: {
        locale: 'en-US',
        formatLocale: enUS,
    },
    fr: {
        locale: 'fr-CA',
        formatLocale: frCA,
    },
};

export const getDatePickerLocale = (locale) => {
    return (
        DATE_PICKER_LOCALES[normalizeLocale(locale)] ?? DATE_PICKER_LOCALES.en
    );
};

export const buildLocaleCache = (user, effectiveLocale) => ({
    userId: user?.id ?? null,
    preferredLocale: normalizeLocale(user?.preferred_locale),
    effectiveLocale: normalizeLocale(effectiveLocale),
    publicLocale: getPublicLocale(),
    cachedAt: new Date().toISOString(),
});

export const readLocaleCache = () => {
    if (typeof localStorage === 'undefined') return {};

    try {
        const value = localStorage.getItem(LOCALE_CACHE_KEY);
        return value ? JSON.parse(value) : {};
    } catch (error) {
        return {};
    }
};

export const getPublicLocale = () => {
    const cache = readLocaleCache();

    // effectiveLocale is authenticated, server-confirmed state and can depend
    // on alpha access. Public pages should only restore an explicit public choice.
    return normalizeLocale(cache.publicLocale);
};

export const buildPublicLocaleCache = (locale) => ({
    publicLocale: normalizeLocale(locale),
    cachedAt: new Date().toISOString(),
});
